import { ApolloQueryResult, gql } from '@apollo/client';
import { inject, injectable } from 'tsyringe';
import { AmGraphQlClient } from '../../cross-cutting-concerns/communication/clients/AmGraphQlClient';
import { Foo } from './interfaces/Foo';

export interface FooClientListOptions {
  nextToken?: string;
}

@injectable()
export class FooClient {
  constructor(@inject('AmGraphQlClient') private client: AmGraphQlClient) {}

  public list = async ({ nextToken = undefined }: FooClientListOptions): Promise<ApolloQueryResult<Foo[]>> =>
    this.client.query({
      query: gql`
        query AllTasks {
          allTasks {
            items {
              id
              title
              description
              taskStatus
              owner
            }
            nextToken
          }
        }
      `,
      variables: {
        nextToken,
      },
    });
}
